import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { EventGameDetails } from "src/_common/interfaces/models/event";
import { StateExtended } from "../../interfaces/StateExtended";

export function useAppEvenListSelector() {
  const eventList = useSelector((state: StateExtended) => state.event.getEventList);
  return eventList;
}

export function useAppEventGameListSelector() {
  const eventGameList = useSelector((state: StateExtended) => state.event.getEventGameList);
  return eventGameList;
}

export function useAppPerformanceListSelector() {
  const performance = useSelector((state: StateExtended) => state.event.getPerformanceList);
  return performance;
}

export function useAppEventGameDetailSelector() {
  const eventGameDetails = useSelector((state: StateExtended) => state.event.getEventGameDetails);
  return eventGameDetails;
}

export function useAppEventStatusMessageSelector() {
  const statusMessage = useSelector((state: StateExtended) => state.event.getEventStatusMessage);
  return statusMessage;
}

export function useAppIrStatusMessageSelector() {
  const statusMessage = useSelector((state: StateExtended) => state.event.getIrStatusMessage);
  return statusMessage;
}

export function useAppEventLeaderBoardSelector() {
  const leaderBoard = useSelector((state: StateExtended) => state.event.getLeaderBoard);
  return leaderBoard;
}

export function useAppTvImageSelector() {
  const tvImage = useSelector((state: StateExtended) => state.event.getTvImageDetails);
  return tvImage;
}

export function useAppGameWiningTruckDetailsSelector() {
  const winingTruck = useSelector((state: StateExtended) => state.event.getWiningTruckDetails);
  return winingTruck;
}

export function useAppWiningTruckModalOpen() {
  const winingModal = useSelector((state: StateExtended) => state.event.winingTruckModalShow);
  return winingModal;
}
export const useAppNextEventRouteSelector = () => {
  const activeRoute = useSelector((state: StateExtended) => state.event.fromRoute);
  return activeRoute;
};
export const useAppPickIdsSelector = () => {
  const pick_id = useSelector((state: StateExtended) => state.event.pick_id);
  return pick_id;
};
export const useAppRodeoEventLoginRequiredSelector = () => {
  const login_required = useSelector((state: StateExtended) => state.event.login_required);
  return login_required;
};
export const useAppSiteHeaderSelector = () => {
  const site_header = useSelector((state: StateExtended) => state.event.site_header);
  return site_header;
};
export const useAppGameDetailsSelector = () => {
  const gameDetails = useSelector((state: StateExtended) => state.event.gameDetails);
  return gameDetails;
};

export function useAppRodeoEventSettingsSelector() {
  const rodeoEventSettings = useSelector((state: StateExtended) => state.event.rodeoEventSettings);
  return rodeoEventSettings;
}
